var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"vpd-content",attrs:{"fluid":""}},[_c('vpd-service-summary-panel',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }